<template>
    <client-page>

        <sub-visual
        sh="What We Do"
        tabActive="Information Security Management"
        bg="/images/sub/visual/sv4.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <div class="page-tit-wrap">
                    <h2 class="page-tit">
                        Information <br class="d-none d-md-block">
                        Security Management
                    </h2>
                    <p>
                        Proactively manage and protect your information and assets. <br>
                        Systematically manage the history of data that is exported or brought in by using a security program.
                    </p>
                </div>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Document Centralization">
                    <v-img src="/images/sub/wwd/information/info-img1-en.png" max-width="950" class="mx-auto"></v-img>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Security document grading">
                    <p class="page-text dot-txt color-grey-2c mb-8 mb-lg-14">
                        Operated by giving a <strong class="font-weight-bold color-point">Security Level</strong> for each folder
                    </p>
                    <div class="w-100 border pa-20 pa-md-30 pt-lg-38 pb-lg-60 mb-18 mb-lg-34">
                        <v-img src="/images/sub/wwd/information/info-img2-en.png" max-width="709" class="mx-auto"></v-img>
                    </div>
                    <p class="page-text dot-txt color-grey-2c mb-8 mb-lg-14">
                        정보자산 중요도
                    </p>
                    <table class="client-table w-100">
                        <colgroup>
                            <col style="width: 20%">
                            <col style="width: 11%">
                            <col style="width: 11%">
                            <col style="width: 11%">
                            <col style="width: 47%">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>
                                    <div class="table-inner">Division</div>
                                </th>
                                <th>
                                    <div class="table-inner">Level</div>
                                </th>
                                <th>
                                    <div class="table-inner">Value</div>
                                </th>
                                <th>
                                    <div class="table-inner">Evaluation Scope</div>
                                </th>
                                <th>
                                    <div class="table-inner">Contents</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th rowspan="3">
                                    <div class="table-inner">Information Asset Importance</div>
                                </th>
                                <td>
                                    <div class="table-inner">Lv. 1</div>
                                </td>
                                <td>
                                    <div class="table-inner">1</div>
                                </td>
                                <td>
                                    <div class="table-inner color-point font-weight-bold">8~9 Points</div>
                                </td>
                                <td>
                                    <div class="table-inner left px-xl-40">Core assets necessary to conduct business</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="table-inner">Lv. 2</div>
                                </td>
                                <td>
                                    <div class="table-inner">2</div>
                                </td>
                                <td>
                                    <div class="table-inner color-point font-weight-bold">5~7 Points</div>
                                </td>
                                <td>
                                    <div class="table-inner left px-xl-40">Key assets that affect business performance</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="table-inner">Lv. 3</div>
                                </td>
                                <td>
                                    <div class="table-inner">3</div>
                                </td>
                                <td>
                                    <div class="table-inner color-point font-weight-bold">3~4 Points</div>
                                </td>
                                <td>
                                    <div class="table-inner left px-xl-40">Core assets and general assets that support them</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <sub-line-layout tit="PC with security program applied">
                    <v-row class="my-n10 my-lg-n40">

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon1.png"
                        iconWidth="48">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                After blocking/controlling the local PC storage of documents, transfer them to a central server, central management of corporate documents.
                            </p>
                            <p class="dot-txt sm grey-2c">
                                Prevents ransomware infection in advance by not leaving documents on the user's PC
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon2.png"
                        iconWidth="50">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                External hard drive, screen capture, USB control, CD Rom control, print control, attachment control, shared folder control and remote program access control
                            </p>
                            <p class="dot-txt sm grey-2c">
                                Internal/external file access control through IP policy
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon3.png"
                        iconWidth="48">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                Support for collaboration only for files paid by the file export transfer payment system
                            </p>
                            <p class="dot-txt sm grey-2c">
                                Document history management with multi-level payment system
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon4.png"
                        iconWidth="50">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                Protection of corporate document assets through file encryption in central server storage and personal information encryption
                            </p>
                            <p class="dot-txt sm grey-2c">
                                Computer virus treatment and removal through real-time scanning
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon5.png"
                        iconWidth="54">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                Save large files and avoid speed issues by designating a local area
                            </p>
                            <p class="dot-txt sm grey-2c">
                                Supports file backup and capacity setting in the secure drive area
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon6.png"
                        iconWidth="52">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                Detection of specific security keywords set by the title, personal information inserted in the body, and corporate policy
                            </p>
                            <p class="dot-txt sm grey-2c">
                                When detected, the document is quarantined to block leakage to the outside and file quarantine alarm function
                            </p>
                        </sub-icon-box>

                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/en/sub/sub-line-layout.vue";
import SubIconBox from "@/components/client/en/sub/sub-icon-box.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubIconBox,
    },
};
</script>

<style lang="scss" scoped>
</style>